// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BREAKPOINTS */
.Portal_templateGrid__EkIx8 {
  position: relative;
  z-index: 0;
  min-height: 100vh;
  display: grid;
  background-color: var(--background-color-1);
  transition: background 0.3s ease;
  grid-template: "header" auto "main" 1fr "footer" auto "systemStatus" auto/100%;
}
.Portal_templateGrid__EkIx8.Portal_f1__n9wbr {
  background: var(--grassColor);
}
.Portal_templateGrid__EkIx8.Portal_f1__n9wbr .Portal_main__cea2L {
  background: none !important;
  box-shadow: none;
}
.Portal_templateGrid__EkIx8:not(.Portal_f1__n9wbr) .Portal_clouds__Mc3Su {
  opacity: 0;
}
.Portal_templateGrid__EkIx8.Portal_collapsed__I7QmK .Portal_mainWrap__L4RQo {
  display: contents;
}
.Portal_templateGrid__EkIx8.Portal_collapsed__I7QmK .Portal_main__cea2L {
  box-shadow: none;
  padding: 0;
  margin: 0;
}
.Portal_templateGrid__EkIx8 .Portal_main__cea2L {
  grid-area: main;
  background: var(--background-color-1) !important;
  margin: 2em 0;
  box-shadow: 0 0 0 2em var(--background-color-1);
}
@media (min-width: 768px) {
  .Portal_templateGrid__EkIx8 .Portal_main__cea2L {
    border-radius: 1px;
  }
}
.Portal_templateGrid__EkIx8 .Portal_main__cea2L.Portal_noBackground__HUri- {
  background: none !important;
  box-shadow: none;
}
.Portal_templateGrid__EkIx8 .Portal_wavesContainer__ZkB3\\+ {
  position: absolute;
  left: 0;
  right: 0;
  overflow: hidden;
  z-index: -1000;
}
.Portal_templateGrid__EkIx8 .Portal_shape__pHoHv {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  clip-path: url(#waveShape);
  overflow: hidden;
  width: 100%;
  height: 30em;
  background-color: var(--background-color-2);
}
@media (max-width: 991.98px) {
  .Portal_templateGrid__EkIx8 .Portal_shape__pHoHv {
    --width: 992px;
    width: var(--width);
    left: auto;
    left: initial;
    right: 0;
  }
}
.Portal_templateGrid__EkIx8 .Portal_footer__Kkd5s {
  padding: 1em;
  grid-area: footer;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: var(--foreground-color-1);
}
.Portal_templateGrid__EkIx8.nightMode.Portal_f1__n9wbr .Portal_shape__pHoHv {
  background-image: linear-gradient(black, var(--blue));
}`, "",{"version":3,"sources":["webpack://./src/core/_breakpoints.scss","webpack://./src/views/Template/Portal.module.scss"],"names":[],"mappings":"AAAA,gBAAA;ACCA;EACE,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,aAAA;EACA,2CAAA;EACA,gCAAA;EAaA,8EACE;AAZJ;AADE;EACE,6BAAA;AAGJ;AAFI;EACE,2BAAA;EACA,gBAAA;AAIN;AAAI;EACE,UAAA;AAEN;AAQI;EACE,iBAAA;AANN;AAQI;EACE,gBAAA;EACA,UAAA;EACA,SAAA;AANN;AASE;EACE,eAAA;EACA,gDAAA;EACA,aAAA;EACA,+CAAA;AAPJ;AD1BI;EC6BF;IAMI,kBAAA;EALJ;AACF;AAMI;EACE,2BAAA;EACA,gBAAA;AAJN;AAOE;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,gBAAA;EACA,cAAA;AALJ;AAOE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,0BAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,2CAAA;AALJ;AD7BI;ECyBF;IAWI,cAAA;IACA,mBAAA;IACA,UAAA;IAAA,aAAA;IACA,QAAA;EAHJ;AACF;AAKE;EACE,YAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gCAAA;AAHJ;AAOM;EACE,qDAAA;AALR","sourcesContent":["/* BREAKPOINTS */\n@mixin breakpoint-up($point) {\n  @if $point == sm {\n    @media (min-width: 576px) {\n      @content;\n    }\n  } @else if $point == md {\n    @media (min-width: 768px) {\n      @content;\n    }\n  } @else if $point == lg {\n    @media (min-width: 992px) {\n      @content;\n    }\n  } @else if $point == xl {\n    @media (min-width: 1200px) {\n      @content;\n    }\n  }\n}\n\n@mixin breakpoint-down($point) {\n  @if $point == xs {\n    @media (max-width: 575.98px) {\n      @content;\n    }\n  } @else if $point == sm {\n    @media (max-width: 767.98px) {\n      @content;\n    }\n  } @else if $point == md {\n    @media (max-width: 991.98px) {\n      @content;\n    }\n  } @else if $point == lg {\n    @media (max-width: 1199.98px) {\n      @content;\n    }\n  }\n}\n","@import \"core/_breakpoints.scss\";\n.templateGrid {\n  position: relative;\n  z-index: 0;\n  min-height: 100vh;\n  display: grid;\n  background-color: var(--background-color-1);\n  transition: background 0.3s ease;\n  &.f1 {\n    background: var(--grassColor);\n    .main {\n      background: none !important;\n      box-shadow: none;\n    }\n  }\n  &:not(.f1) {\n    .clouds {\n      opacity: 0;\n    }\n  }\n  grid-template:\n    \"header\" auto\n    \"main\" 1fr\n    \"footer\" auto\n    \"systemStatus\" auto\n    / 100%;\n  &.collapsed {\n    .mainWrap {\n      display: contents;\n    }\n    .main {\n      box-shadow: none;\n      padding: 0;\n      margin: 0;\n    }\n  }\n  .main {\n    grid-area: main;\n    background: var(--background-color-1) !important;\n    margin: 2em 0;\n    box-shadow: 0 0 0 2em var(--background-color-1);\n    @include breakpoint-up(md) {\n      border-radius: 1px;\n    }\n    &.noBackground {\n      background: none !important;\n      box-shadow: none;\n    }\n  }\n  .wavesContainer {\n    position: absolute;\n    left: 0;\n    right: 0;\n    overflow: hidden;\n    z-index: -1000;\n  }\n  .shape {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: -1;\n    clip-path: url(#waveShape);\n    overflow: hidden;\n    width: 100%;\n    height: 30em;\n    background-color: var(--background-color-2);\n    @include breakpoint-down(md) {\n      --width: 992px;\n      width: var(--width);\n      left: unset;\n      right: 0;\n    }\n  }\n  .footer {\n    padding: 1em;\n    grid-area: footer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    color: var(--foreground-color-1);\n  }\n  &:global(.nightMode) {\n    &.f1 {\n      .shape {\n        background-image: linear-gradient(black, var(--blue));\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"templateGrid": `Portal_templateGrid__EkIx8`,
	"f1": `Portal_f1__n9wbr`,
	"main": `Portal_main__cea2L`,
	"clouds": `Portal_clouds__Mc3Su`,
	"collapsed": `Portal_collapsed__I7QmK`,
	"mainWrap": `Portal_mainWrap__L4RQo`,
	"noBackground": `Portal_noBackground__HUri-`,
	"wavesContainer": `Portal_wavesContainer__ZkB3+`,
	"shape": `Portal_shape__pHoHv`,
	"footer": `Portal_footer__Kkd5s`
};
export default ___CSS_LOADER_EXPORT___;
